import { useWindowDimensions } from "react-native";

export default function useLgMediaQuery() {
  const { width } = useWindowDimensions();
  return width >= 1024;
}
